var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card } from '@homeexchange/design';
import { buildFavoriteFolderName } from '@homeexchange/home';
import React, { useCallback, useState } from 'react';
import i18n from '../../../i18n';
import Utils from '../../../utils/utils';
import Analytics from '../../../utils/analytics';
import { NAVIGATION_ACTION, NAVIGATION_AREAS, NAVIGATION_TEXT } from '../../analytics/analytics-constants';
import useGTM from '../../analytics/useGTM';
var COLLECTION_STATUS = {
    ACTIVE: 2,
    NOT_ACTIVE: 1
};
export function HomeCard(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var result = _a.result, locale = _a.locale, isLogged = _a.isLogged, isUserCollection = _a.isUserCollection, homeFavorites = _a.homeFavorites, handleToggleFavorite = _a.handleToggleFavorite, onRemoveFavorite = _a.onRemoveFavorite, onMoveFavorite = _a.onMoveFavorite, format = _a.format, _t = _a.hideFixedDates, hideFixedDates = _t === void 0 ? false : _t, onClose = _a.onClose, user = _a.user, searchFilters = _a.searchFilters, trackingEvent = _a.trackingEvent, origin = _a.origin;
    var url = i18n.t('url:home.view_not_logged.url', { id: result.attributes.homeId });
    if (isLogged) {
        url = i18n.t('home:home.view.url', { id: result.attributes.homeId });
    }
    var userUrl = i18n.t('user:user.view.url', {
        id: result.attributes.user.attributes.userId
    });
    var fetchNavigation = useGTM(user).fetchNavigation;
    var _u = useState(false), isOpenFavoriteMenu = _u[0], setIsOpenFavoriteMenu = _u[1];
    var isFavorite = homeFavorites.includes(result.attributes.homeId);
    var trackFavoriteEvent = useCallback(function () {
        Analytics.trackGTM('MixpanelAddFavorites', {
            userStatus: user.getStatus()
        });
        Analytics.trackGTM('HandleFavorites', {
            event_data: __assign({ action: NAVIGATION_ACTION.CLICK, text: 'heart_home_card', area: format === 'map' ? 'search_page_map' : 'search' }, (origin && { origin: origin }))
        });
    }, [user, format, origin]);
    var handleFavorite = useCallback(function (e) {
        var _a, _b, _c, _d, _e;
        e.stopPropagation();
        if (isLogged) {
            trackFavoriteEvent();
            if (isFavorite) {
                setIsOpenFavoriteMenu(function (prev) { return !prev; });
            }
            else {
                var city = (_a = result.attributes.translations) === null || _a === void 0 ? void 0 : _a.location.city[locale];
                var country = (_b = result.attributes.translations) === null || _b === void 0 ? void 0 : _b.location.country[locale];
                var year = ((_e = (_d = (_c = searchFilters === null || searchFilters === void 0 ? void 0 : searchFilters.calendar) === null || _c === void 0 ? void 0 : _c.date_ranges) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.from)
                    ? new Date(searchFilters.calendar.date_ranges[0].from).getFullYear()
                    : undefined;
                var prefillName = buildFavoriteFolderName({ city: city, country: country, year: year });
                handleToggleFavorite(result.attributes.homeId, prefillName);
            }
        }
        else {
            Analytics.trackGTM('button', fetchNavigation(NAVIGATION_ACTION.CLICK, NAVIGATION_AREAS.HOMECARD_MAP_FAVORITES, NAVIGATION_TEXT.ADD_TO_FAVORITES_SIGN_UP));
            document.dispatchEvent(new CustomEvent('open_signup_popup'));
        }
    }, [
        isLogged,
        isFavorite,
        handleToggleFavorite,
        result.attributes.homeId,
        result.attributes.translations,
        locale,
        searchFilters,
        trackFavoriteEvent,
        fetchNavigation
    ]);
    var favoriteMenuItems = __spreadArray(__spreadArray([], (onMoveFavorite
        ? [
            {
                label: i18n.t('home:global_favorites_folderChange'),
                onClick: function (e) {
                    e.stopPropagation();
                    setIsOpenFavoriteMenu(false);
                    onMoveFavorite(result.attributes.homeId);
                },
                icon: 'ArrowsDiagonal'
            }
        ]
        : []), true), (onRemoveFavorite
        ? [
            {
                label: i18n.t('home:global_favorites_remove'),
                onClick: function (e) {
                    e.stopPropagation();
                    setIsOpenFavoriteMenu(false);
                    onRemoveFavorite(result.attributes.homeId);
                },
                icon: 'Cross'
            }
        ]
        : []), true);
    var getLocation = useCallback(function (result) {
        var _a, _b, _c, _d, _e, _f;
        return (((_b = (_a = result.attributes.translations) === null || _a === void 0 ? void 0 : _a.location.city[locale]) !== null && _b !== void 0 ? _b : '') +
            (((_c = result.attributes.translations) === null || _c === void 0 ? void 0 : _c.location.city[locale]) &&
                ((_d = result.attributes.translations) === null || _d === void 0 ? void 0 : _d.location.country[locale])
                ? ', '
                : '') +
            ((_f = (_e = result.attributes.translations) === null || _e === void 0 ? void 0 : _e.location.country[locale]) !== null && _f !== void 0 ? _f : ''));
    }, [locale]);
    var getImages = useCallback(function (result) {
        var _a, _b;
        var homeImages = (_b = (_a = result.attributes.images) === null || _a === void 0 ? void 0 : _a.home) !== null && _b !== void 0 ? _b : [];
        return isLogged ? homeImages : homeImages.slice(0, 1);
    }, [isLogged]);
    var getFlexibleSearch = function (nextAvailability) {
        // Parse dates
        var fromDate = new Date(nextAvailability.from);
        var toDate = new Date(nextAvailability.to);
        var formatDateRange = function (date) {
            return date.toLocaleDateString(i18n.language, {
                day: 'numeric',
                month: 'long'
            });
        };
        // Calculate duration in nights
        var durationInNights = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24));
        // Get month names
        var fromMonth = fromDate.toLocaleString(i18n.language, { month: 'long' });
        var toMonth = toDate.toLocaleString(i18n.language, { month: 'long' });
        var dateRange = "".concat(formatDateRange(fromDate), " - ").concat(formatDateRange(toDate));
        // Determine type based on duration
        if (durationInNights === 1) {
            return formatDateRange(fromDate);
        }
        else if (durationInNights <= 14) {
            return dateRange;
        }
        else if (durationInNights >= 14) {
            return fromMonth === toMonth
                ? i18n.t('search:global.flexibleSearch.severalWeeks', { month: fromMonth })
                : i18n.t('search:global.flexibleSearch.severalWeeks', {
                    month: fromMonth
                }) + ", ".concat(toMonth);
        }
        else {
            return "from ".concat(nextAvailability.from, " to ").concat(nextAvailability.to);
        }
    };
    // Check if we should show dates on the card
    // Show dates if there is flexibility in the search filters or hideFixedDates is false
    var shouldShowDates = function () {
        if (!result.attributes.searchContext || !result.attributes.searchContext.next_availability) {
            return true;
        }
        if (!searchFilters || !searchFilters.calendar || !searchFilters.calendar.date_ranges) {
            return true;
        }
        if (!hideFixedDates) {
            return true;
        }
        var hasDateFlexibility = searchFilters.calendar.flexibility !== undefined && searchFilters.calendar.flexibility !== null;
        var hasDurationFlexibility = searchFilters.calendar.duration !== undefined && searchFilters.calendar.duration !== null;
        return hasDateFlexibility || hasDurationFlexibility;
    };
    return (React.createElement(Card, __assign({ images: getImages(result), userImg: (_c = (_b = result.attributes.images) === null || _b === void 0 ? void 0 : _b.user) !== null && _c !== void 0 ? _c : "".concat(Utils.getAssetsDomain(), "/images/website/default-user-26x26.png"), title: (_e = (_d = result.attributes.translations) === null || _d === void 0 ? void 0 : _d.title[locale]) !== null && _e !== void 0 ? _e : '', location: getLocation(result), format: format, GPCostByNightText: "".concat(result.attributes.gpPerNight, " ").concat(i18n.t('home:gp_per_night')), verify: result.attributes.isVerified, loyaltyBadge: result.attributes.user.attributes.loyaltyBadge === 0
            ? undefined
            : result.attributes.user.attributes.loyaltyBadge, isPrivateRoom: result.attributes.isPrivateRoom, isPrivateRoomTagText: i18n.t('global:global.privateRoom'), displayFavorite: true, isFavorite: isFavorite, isOpenFavoriteMenu: isOpenFavoriteMenu, favoriteMenuItems: favoriteMenuItems, rating: result.attributes.homeRatingsCount > 0 && ((_f = result.attributes.user.attributes.rating) === null || _f === void 0 ? void 0 : _f.toFixed(1)), reviews: result.attributes.homeRatingsCount, onClose: function () {
            onClose();
        } }, (isUserCollection &&
        ((_g = result.attributes.flags) === null || _g === void 0 ? void 0 : _g.status_he_collection) === COLLECTION_STATUS.ACTIVE
        ? {
            isCollection: true,
            isCollectionTagText: i18n.t('home:label_collection')
        }
        : {
            isCollection: false
        }), (((_h = result.attributes.userContext) === null || _h === void 0 ? void 0 : _h.alreadyContacted) && {
        alreadyContacted: true,
        alreadyContactedTagText: i18n.t('home:already_contacted')
    }), (result.attributes.minimumOfNights > 0 && {
        hasMinimumOfNights: true,
        hasMinimumOfNightsTagText: i18n.t('home:home_cards_minimum_number_of_nights', {
            number: result.attributes.minimumOfNights
        })
    }), (((_j = result.attributes.beds) === null || _j === void 0 ? void 0 : _j.bedsCount) > 0 && {
        showBeds: true,
        bedsText: i18n.t('global:global.bedsNumber', {
            count: (_k = result.attributes.beds) === null || _k === void 0 ? void 0 : _k.bedsCount
        })
    }), (((_l = result.attributes.beds) === null || _l === void 0 ? void 0 : _l.bedroomsCount) > 0 && {
        showBedrooms: true,
        bedroomsText: i18n.t('global:global.bedroomsNumbers', {
            count: (_m = result.attributes.beds) === null || _m === void 0 ? void 0 : _m.bedroomsCount
        })
    }), (isLogged &&
        ((_p = (_o = result.attributes.searchContext) === null || _o === void 0 ? void 0 : _o.next_availability) === null || _p === void 0 ? void 0 : _p.from) &&
        ((_r = (_q = result.attributes.searchContext) === null || _q === void 0 ? void 0 : _q.next_availability) === null || _r === void 0 ? void 0 : _r.to) &&
        shouldShowDates() && {
        flexibleSearch: getFlexibleSearch((_s = result.attributes.searchContext) === null || _s === void 0 ? void 0 : _s.next_availability),
        flexibleSearchText: i18n.t('global:global.status.available')
    }), (isLogged &&
        result.attributes.contactAllowed &&
        (!result.attributes.searchContext ||
            Object.keys(result.attributes.searchContext).length === 0) && {
        flexibleSearchText: i18n.t('search:global.status.openedCalendar')
    }), { url: url, onTracking: function () {
            if (trackingEvent) {
                Analytics.trackGTM('HomeCard', {
                    event_data: __assign({ action: NAVIGATION_ACTION.CLICK, text: trackingEvent, area: format === 'map' ? 'search_page_map' : 'search' }, (origin && { origin: origin }))
                });
            }
        }, onClickUser: function (e) {
            if (!isLogged) {
                e.stopPropagation();
                Analytics.trackGTM('button', fetchNavigation(NAVIGATION_ACTION.CLICK, format === 'map'
                    ? NAVIGATION_AREAS.HOMECARD_MAP_PHOTO
                    : NAVIGATION_AREAS.HOMECARD_RESULTS_PHOTO, NAVIGATION_TEXT.PHOTO_SIGN_UP));
                document.dispatchEvent(new CustomEvent('open_signup_popup'));
            }
            else {
                window.open(userUrl, '_blank');
            }
        }, onFavorite: handleFavorite })));
}
